// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DesktopCategoryFilter_trip-filter__FlcCI{
    width: 83vw;
    height: 5vw;
    margin-left: auto;
    margin-right: auto;
    border-radius: 100vw;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    flex-direction: row;
    margin-top: 1.5vw;
 }
 
 
 .DesktopCategoryFilter_filter-buttons-container__HIQpK{
    display: flex;
    width: 50vw;
    justify-content: space-between;
    margin: auto;
    margin-left: 1vw;
 }
 
 
 .DesktopCategoryFilter_filter-buttons__O9ylt{
    border: none;
    border-radius: 100vw;
    height: 2.5vw;
    font-size: 1vw;
    padding-left: 1vw;
    padding-right: 1vw;
    background-color: rgba(13,7,20,0.05);
    font-family: dm-sans-light;
 }
 
 
 .DesktopCategoryFilter_filter-buttons__O9ylt:hover{
    background-color: #e65439;
    color: white;
    cursor: pointer;
 }
 
 
 .DesktopCategoryFilter_month-dropdown-adjust__k5rPp{
    position: absolute;
    z-index: 2;
    width: 18vw;
    height: 3vw;
    /* background-color: powderblue; */
    margin-top: 1vw;
    margin-left: 62.5vw;
    margin-right: 5vw;
 }
 `, "",{"version":3,"sources":["webpack://./src/Global/DesktopCategoryFilter/DesktopCategoryFilter.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,iBAAiB;CACpB;;;CAGA;IACG,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;CACnB;;;CAGA;IACG,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,0BAA0B;CAC7B;;;CAGA;IACG,yBAAyB;IACzB,YAAY;IACZ,eAAe;CAClB;;;CAGA;IACG,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,mBAAmB;IACnB,iBAAiB;CACpB","sourcesContent":[".trip-filter{\n    width: 83vw;\n    height: 5vw;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 100vw;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);\n    display: flex;\n    flex-direction: row;\n    margin-top: 1.5vw;\n }\n \n \n .filter-buttons-container{\n    display: flex;\n    width: 50vw;\n    justify-content: space-between;\n    margin: auto;\n    margin-left: 1vw;\n }\n \n \n .filter-buttons{\n    border: none;\n    border-radius: 100vw;\n    height: 2.5vw;\n    font-size: 1vw;\n    padding-left: 1vw;\n    padding-right: 1vw;\n    background-color: rgba(13,7,20,0.05);\n    font-family: dm-sans-light;\n }\n \n \n .filter-buttons:hover{\n    background-color: #e65439;\n    color: white;\n    cursor: pointer;\n }\n \n \n .month-dropdown-adjust{\n    position: absolute;\n    z-index: 2;\n    width: 18vw;\n    height: 3vw;\n    /* background-color: powderblue; */\n    margin-top: 1vw;\n    margin-left: 62.5vw;\n    margin-right: 5vw;\n }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trip-filter": `DesktopCategoryFilter_trip-filter__FlcCI`,
	"filter-buttons-container": `DesktopCategoryFilter_filter-buttons-container__HIQpK`,
	"filter-buttons": `DesktopCategoryFilter_filter-buttons__O9ylt`,
	"month-dropdown-adjust": `DesktopCategoryFilter_month-dropdown-adjust__k5rPp`
};
export default ___CSS_LOADER_EXPORT___;
